import { ExchangeRateActionTypes } from './types';

export const changeExchangeRate = (
  exchangeRate: ExchangeRate,
): { type: ExchangeRateActionTypes; payload: ExchangeRate } => ({
  type: ExchangeRateActionTypes.ChangeExchangeRate,
  payload: exchangeRate,
});
